<template>
	<div v-parallax-fit="parallax" ref="start1" class="start">
		<img src="/themes/rise-theme/dist/images/estate/character-view/holly/01_Typewriter.png" alt="">
	</div>
</template>

<script>
import { store } from '../../store';

export default {
	data() {
		return {
			store,
			subtitlesUrl: {
				'en': '/themes/rise-theme/resources/assets/audio/holly/1.srt',
				'es': '/themes/rise-theme/resources/assets/audio/holly/1_es.srt'
			},
			mutationObserver: null,
			autoStartClip: true,
			parallax: [
				{
					start: 0,
					end: 400,
					fromStyle: { transform: 'translateX(-50%) translateY(-50%) scale(1) rotate(0deg)' },
					toStyle: { transform: 'translateX(-50%) translateY(-50%) scale(2) rotate(0deg)' },
					easing: 'linear'
				},
				{
					start: 2600,
					end: 3000,
					fromStyle: { transform: 'translateX(-50%) translateY(-50%) scale(2) rotate(0deg)', opacity: 1 },
					toStyle: { transform: 'translateX(-50%) translateY(100%) scale(1.5) rotate(0deg)', opacity: 0 },
					easing: 'linear'
				}
			]
		}
	},
	created() {
		this.$watch('$route.meta', (newVal) => {
			this.autoStartClip = !newVal.intro;
		}, { immediate: true });
		const unwatch = this.$watch('$tutorial.value', newVal => {
			this.autoStartClip = newVal;
			this.emitter.emit('auto-play');
			unwatch();
		});
		this.$watch('store.lang', newVal => {
			if (Object.values(this.subtitlesUrl).includes(this.$subtitlesUrl.value)) {
				this.$subtitlesUrl.value = this.subtitlesUrl[newVal]
			}
		}, { immediate: true });

	},
	mounted() {
		const self = this;
		const audio = '/themes/rise-theme/resources/assets/audio/holly/1.mp3';
		this.mutationObserver = new window.MutationObserver(mutationList => {
			mutationList.forEach(mutation => {
				if (mutation.target.style.transform == 'translateX(-50%) translateY(-50%) scale(2) rotate(0deg)') {
					this.$evidence.value = null;
					this.$audioUrl.value = audio;
					this.$subtitlesUrl.value = this.subtitlesUrl[this.store.lang]
					this.$readMore.value = '';
				}
			});
		});

		this.mutationObserver.observe(this.$refs.start1, {
			attributes: true,
			attributeFilter: ['style']
		});

		this.$evidence.value = null;
		this.$readMore.value = '';
		this.$audioUrl.value = audio;
		this.$subtitlesUrl.value = this.subtitlesUrl[this.store.lang];

		self.emitter.on('player-ready', () => {
			console.log('player-ready event catch')
			setTimeout(() => {
				if (self.autoStartClip) {
					self.emitter.emit('auto-play');
				}
			}, 500);
		});

	},
	unmounted() {
		this.mutationObserver.disconnect();
	}
}
</script>

<style lang="scss" scoped>
.start {
	position: absolute;
	top: 50%;
	left: 50%;
	z-index: 2;
	max-width: 500px;
	transition: all 0.1s linear;
}

@media screen and (max-width: 1024px) {
	.start {
		max-width: 300px;
	}
}
</style>
